import api from "csi/api";
import Table from "csi/table/Widget";
import declare from "dojo/_base/declare";

const ACTION_COLORWAY = "PopupStyleLineItemColorways";

const StyleLineItemsTable = declare(Table, {
	/**
	 * @override
	 * Exclude Colorways action from ellipses, so that it will be displayed as icon
	 */
	_resolveView() {
		api.excludeActionFromEllipses(ACTION_COLORWAY);
		this.inherited(arguments);
	},
});

export = StyleLineItemsTable;
